import React, { ReactElement, useEffect, useRef, useState } from 'react';
import './VolumeTabBar.scss';
import InkyPenSelectMenu from '../../../../InkyPenUIKit/InkyPenSelectMenu/InkyPenSelectMenu';
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import localeData from 'dayjs/plugin/localeData';

dayjs.extend(LocalizedFormat);
dayjs.extend(localeData);

const VolumeTabBar = ({
                          count,
                          volumes,
                          seriesType,
                      }): ReactElement => {
    const [isCover, setIsCover] = useState(false);

    const tabBarRef = useRef(null);
    const initialOffsetTop = useRef(0);

    const scrollToItem = (number: number): void => {
        const itemRef = document.getElementById('volume-' + number.toString());
        const headerOffset = 200;
        const elementPosition = itemRef.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        });
        // itemRef?.scrollIntoView({ behavior: 'smooth' });
    };

    const onScrolled = (): void => {
        const offsetTop = tabBarRef.current?.getBoundingClientRect().top;
        if (offsetTop <= 94) {
            setIsCover(true);
        } else {
            setIsCover(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', onScrolled);
        initialOffsetTop.current = tabBarRef.current?.offsetTop;

        return (): void => {
            window.removeEventListener('scroll', onScrolled);
        };
    }, []);

    function volumeToLabel(v: any) {
        if (seriesType === 4) {
            //strip
            return 'Episode ' + v.readable.releaseDate.format(dayjs().localeData().longDateFormat('L'));
        } else {
            return v.volumeNumber ? v.volumeNumber : v.name;
        }
    }

    function renderTitle() {
        const { volumesCount, issuesCount, episodesCount } = count;
        const parts = [];

        if (volumesCount > 0) parts.push(`${volumesCount} Volume${volumesCount > 1 ? 's' : ''}`);
        if (issuesCount > 0) parts.push(`${issuesCount} Issue${issuesCount > 1 ? 's' : ''}`);
        if (episodesCount > 0) parts.push(`${episodesCount} Episode${episodesCount > 1 ? 's' : ''}`);

        return parts.length > 0 ? parts.join(' & ') : '';
    }

    return (
        <div onScroll={onScrolled} ref={tabBarRef}
             className='series-tabs-desktop-container'>
            {isCover && <div className='series-tabs-desktop-cover' />}

            <div className='series-tabs-desktop-wrapper'
                 style={{ borderBottom: isCover ? '1px solid #dddddd' : 'none' }}>
                <span className={'series-tabs-desktop-volumes-text'}>
                    {renderTitle()}
                </span>
                <div className={'series-tabs-desktop-cascade-wrapper'}>
                    <InkyPenSelectMenu
                        onItemSelected={(index: number) => {
                            console.log('index', index);
                            scrollToItem(index);
                        }}
                        title={'Jump to ...'}
                        items={volumes?.map(item => volumeToLabel(item))} />
                </div>

                {/*<div className={`${sorted ? 'sort-icons-wrapper-active' : 'sort-icons-wrapper'}`}*/}
                {/*     onClick={sortVolumes}>*/}
                {/*    <SortArrow />*/}
                {/*    <SortArrow />*/}
                {/*</div>*/}


                {/*{areThereFreeChapters && <div onClick={() => setShowChapters(showChapters => !showChapters)}*/}
                {/*      className='series-tabs-desktop-chapters-show-wrapper'>*/}
                {/*    <div className='series-tabs-desktop-chapters-show-text'>*/}
                {/*        {showChapters ? 'HIDE' : 'SHOW'} CHAPTERS*/}
                {/*    </div>*/}

                {/*    <div className='series-tabs-desktop-chapters-show-plus'>*/}
                {/*        {showChapters ? '-' : '+'}*/}
                {/*    </div>*/}
                {/*</div>}*/}

            </div>
        </div>
    );
};

export default React.memo(VolumeTabBar);